import axios from 'axios';
import { retryAdapterEnhancer } from 'axios-extensions';
const withRetry = retryAdapterEnhancer(axios.defaults.adapter, { times: 20 });
//  const withRetryAndThrottle = throttleAdapterEnhancer(withRetry, { threshold: 2 * 100 });
export const ax = axios.create({
    baseURL: '/',
    headers: {},
    adapter: withRetry,
});
export const specificAxios = ({ headers }) => axios.create({
    baseURL: '/',
    headers,
    adapter: withRetry,
});
